import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { AppManagerService, NetworkService } from '@app/services';
import { AUTHENTICATION_STATUS, AuthService } from '@app/services/auth/auth.service';
import { domChanges } from '@app/shared/utils/utils';
import { onResume } from '@shared/utils/platform';
import { get } from 'lodash';

const SECTIONS = {
  home: 'HOME',
  model: 'MODEL',
  examples: 'EXAMPLES',
  more: 'MORE'
};

@Component({
  selector: 'app-offline',
  templateUrl: './offline.page.html',
  styleUrls: ['./offline.page.scss']
})
export class OfflinePage implements OnInit, OnDestroy {
  title!: string;
  page!: string;
  subscription!: Subscription;

  constructor(
    private appManagerService: AppManagerService,
    private authService: AuthService,
    private network: NetworkService,
    private router: Router
  ) {}

  private get pageWhenOnline() {
    return get(this.router.getCurrentNavigation(), 'extras.state.pageWhenOnline');
  }

  private get isLogged(): boolean {
    return this.authService.getStatus() === AUTHENTICATION_STATUS.LOGGED_ACTIVO2;
  }

  ngOnInit(): void {
    this.title = SECTIONS[this.pageWhenOnline];
    this.page = this.pageWhenOnline;

    this.subscription = onResume().subscribe(async () => {
      if (document.visibilityState !== 'visible') {
        return;
      }

      await domChanges();
      this.retry();
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async retry() {
    const isOnline = await this.network.isOnline();

    if (!isOnline) {
      return;
    }

    await this.appManagerService.setOnline(this.page);
  }

  onSection(section: string) {
    this.title = SECTIONS[section];
    this.page = section;
  }

  showHeader() {
    return this.isLogged;
  }
}
